// useTransition.js
import { ref, reactive, onUnmounted } from "vue";
import { useCssTransitionsStore } from "../store/modules/cssTransitions";
import { ACTION_TRANSITIONS_RESET, GETTER_TRANSITIONS_GET } from "../store/types";

export function useTransition(customDirection = null) {
  const directions = {
    LEFT: { enter: "slideInLeft animated", leave: "slideOutRight animated" },
    RIGHT: { enter: "slideInRight animated", leave: "slideOutLeft animated" },
    UP: { enter: "slideInDown animated", leave: "slideOutUp animated" },
    DOWN: { enter: "slideInUp animated", leave: "slideOutDown animated" },
  };

  const cssTransitionsStore = useCssTransitionsStore();
  const transition = reactive({ classes: directions[customDirection || cssTransitionsStore[GETTER_TRANSITIONS_GET]] });
  const isVisible = ref(false);

  onUnmounted(() => {
    // always reset stored transition to retrieve default value
    cssTransitionsStore[ACTION_TRANSITIONS_RESET]();
  });

  return {
    isVisible,
    transition,
    show: () => {
      isVisible.value = true;
    },
    hide: () => {
      isVisible.value = false;
    },
    transitionUpdate: (val) => {
      // use this function in case you're not using pinia store
      // for example when updating transition while staying in the same page/component
      transition.classes = directions[val];
    },
  };
}
